export enum ProjectPhaseEnum {
    Schetsontwerp = 1,
    VoorlopigOntwerp = 2,
    DefinitiefOntwerp = 3,
    Vergunningaanvraag = 4,
    Oplevering = 5
  }
  